import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  ButtonGroup,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
  Pagination,
  DialogContent,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahMutasiStok = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [openUbah, setOpenUbah] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isMutasiStokSaved, setIsMutasiStokSaved] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);
  const [mutasiStokId, setMutasiStokId] = useState(null);

  // Data Mutasi Stok
  const [noBuktiMutasiStok, setNoBuktiMutasiStok] = useState("");
  const [tglMutasiStok, setTglMutasiStok] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  let tempTglMutasiStok = new Date();
  if (tempTglMutasiStok > new Date(user.tutupperiode.sampaiTanggal)) {
    tempTglMutasiStok = new Date(user.tutupperiode.dariTanggal);
  }
  const [jumlahItem, setJumlahItem] = useState("0");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Data Total
  const [total, setTotal] = useState("0");

  // Data Mutasi Stok Child
  const [idMutasiStokChild, setIdMutasiStokChild] = useState("");
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [saldoStokTanggal, setSaldoStokTanggal] = useState("");
  const [tipeMutasiStokChild, setTipeMutasiStokChild] = useState("MASUK");
  const [quantityLama, setQuantityLama] = useState("0");
  const [quantity, setQuantity] = useState("0");
  const [hargaSatuan, setHargaSatuan] = useState("0");
  const [totalMutasiStokChild, setTotalMutasiStokChild] = useState("0");

  const [mutasiStokChilds, setMutasiStokChilds] = useState([]);

  const [coas, setCoas] = useState([]);
  const [error, setError] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClickOpenUbah = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenUbah(true);
  };

  const handleCloseUbah = () => {
    setOpenUbah(false);
    setIdMutasiStokChild("");
    setKodeStok("");
    setNamaStok("");
    setSaldoStokTanggal("");
    setQuantityLama("");
    setQuantity("");
    setHargaSatuan("");
    setTotalMutasiStokChild("");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const tipeMutasiStokChildOption = ["MASUK", "KELUAR"];
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));

  useEffect(() => {
    getNextKodeMutasiStok(tempTglMutasiStok);
    getMutasiStokById();
    getCoas();
    findDefaultDate();
  }, []);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getNextKodeMutasiStok = async (date) => {
    const nextKodeMutasiStok = await axios.post(
      `${tempUrl}/mutasiStoksNextKode`,
      {
        dariTanggal: user.tutupperiode.dariTanggal,
        sampaiTanggal: user.tutupperiode.sampaiTanggal,
        tglMutasiStok: date,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setNoBuktiMutasiStok(nextKodeMutasiStok.data);
  };

  const getMutasiStokById = async () => {
    if (id) {
      setIsMutasiStokSaved(true);
      setIsInputStok(true);
      setMutasiStokId(id);
      const response = await axios.post(`${tempUrl}/mutasiStoks/${id}`, {
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      });
      // Data Mutasi Stok
      setNoBuktiMutasiStok(response.data.noBuktiMutasiStok);
      setTglMutasiStok(new Date(response.data.tglMutasiStok));

      setKodeCOA(
        response.data.coa &&
          `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`
      );

      // Data Total
      setTotal(response.data.total);

      // Data Mutasi Stok Kredit
      setTipeMutasiStokChild(response.data.tipeMutasiStokChild);

      const response2 = await axios.post(
        `${tempUrl}/mutasiStokChildsByMutasiStok`,
        {
          mutasiStokId: response.data.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        }
      );
      setMutasiStokChilds(response2.data);
      setJumlahItem(response2.data.length);
    }
  };

  const getCoas = async () => {
    const response = await axios.post(`${tempUrl}/coas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCoas(response.data);
  };

  const findDefaultDate = async () => {
    let newPeriodeAwal = new Date(user.tutupperiode.dariTanggal);
    let newPeriodeAkhir = new Date(user.tutupperiode.sampaiTanggal);
    let newToday = new Date();

    let isDateBetween =
      newToday >= newPeriodeAwal && newToday <= newPeriodeAkhir;

    if (isDateBetween) {
      // Default Date Today
      setTglMutasiStok(new Date());
    }
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
    await getSaldoStokTanggal(response.data.kodeStok);
    // setHargaSatuan(response.data.hargaJualStok);
  };

  const getSaldoStokTanggal = async (kode) => {
    if (!kode) return;
    const response = await axios.post(`${tempUrl}/mutasiStokChildStockBalance`, {
      kodeStok: kode,
      tanggal: tglMutasiStok,
      kodeCabang: user.cabang.id,
      _id: user.id,
      token: user.token,
    });
    setSaldoStokTanggal(response.data.quantityStok);
  };

  const saveMutasiStok = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (mutasiStokId !== null) {
      setIsInputStok(true);
      setQuantityLama("0");
      setQuantity("0");
      setHargaSatuan("0");
      setTotalMutasiStokChild("0");
      return;
    }

    let tempValidation = form.checkValidity() && kodeCOA.length !== 0;

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedMutasiStok = await axios.post(`${tempUrl}/saveMutasiStok`, {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,

          // Data Mutasi Stok
          noBuktiMutasiStok,
          tglMutasiStok,
          kodeCOA: kodeCOA.split(" ", 1)[0],
          keterangan,

          // Total
          total,

          // Data Mutasi Stok Kredit
          tipeMutasiStokChild,

          userIdInput: user.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        });
        setIsMutasiStokSaved(true);
        setIsInputStok(true);
        // setLoading(false);
        setMutasiStokId(savedMutasiStok.data.id);
        navigate(
          `/daftarMutasiStok/mutasiStok/tambahMutasiStok/${savedMutasiStok.data.id}`
        );
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const saveMutasiStokChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedMutasiStokChild = await axios.post(
          `${tempUrl}/saveMutasiStokChild`,
          {
            // Data Mutasi Stok Child
            mutasiStokId,
            kodeStok,
            namaStok,
            tipeMutasiStokChild,
            quantity,
            hargaSatuan,
            totalMutasiStokChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Mutasi Stok Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setSaldoStokTanggal("");
        setTipeMutasiStokChild("MASUK");
        setQuantityLama("");
        setQuantity("");
        setHargaSatuan("");
        setTotalMutasiStokChild("");

        let findMutasiStokChild = await axios.post(
          `${tempUrl}/mutasiStokChildsByMutasiStok`,
          {
            mutasiStokId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setMutasiStokChilds(findMutasiStokChild.data);
        setJumlahItem(findMutasiStokChild.data.length);

        let findMutasiStok = await axios.post(
          `${tempUrl}/mutasiStoks/${mutasiStokId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setTotal(findMutasiStok.data.total);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const updateMutasiStokChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedMutasiStokChild = await axios.post(
          `${tempUrl}/updateMutasiStokChild/${idMutasiStokChild}`,
          {
            // Data Mutasi Stok Child
            mutasiStokId,
            kodeStok,
            namaStok,
            tipeMutasiStokChild,
            quantityLama,
            quantity,
            hargaSatuan,
            totalMutasiStokChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Mutasi Stok Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setSaldoStokTanggal("");
        setTipeMutasiStokChild("");
        setQuantityLama("");
        setQuantity("");
        setHargaSatuan("");
        setTotalMutasiStokChild("");

        let findMutasiStokChild = await axios.post(
          `${tempUrl}/mutasiStokChildsByMutasiStok`,
          {
            mutasiStokId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setMutasiStokChilds(findMutasiStokChild.data);
        setJumlahItem(findMutasiStokChild.data.length);

        let findMutasiStok = await axios.post(
          `${tempUrl}/mutasiStoks/${mutasiStokId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setTotal(findMutasiStok.data.total);

        handleCloseUbah();
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const deleteMutasiStokChild = async (e, id, quantity, totalMutasiStokChild) => {
    e.preventDefault();
    e.stopPropagation();

    const confirmed = window.confirm("Yakin ingin menghapus barang ini?");
    if (!confirmed) return;

    const form = e.currentTarget;
    if (form.checkValidity()) {
      // setLoading(true);
      try {
        // setLoading(true);
        let deletedMutasiStokChild = await axios.post(
          `${tempUrl}/deleteMutasiStokChild/${id}`,
          {
            // Data Mutasi Stok Child
            mutasiStokId,
            quantity,
            totalMutasiStokChild,

            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        let findMutasiStokChild = await axios.post(
          `${tempUrl}/mutasiStokChildsByMutasiStok`,
          {
            mutasiStokId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setMutasiStokChilds(findMutasiStokChild.data);
        setJumlahItem(findMutasiStokChild.data.length);

        let findMutasiStok = await axios.post(
          `${tempUrl}/mutasiStoks/${mutasiStokId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setTotal(findMutasiStok.data.total);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const saveMutasiStokTotal = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempValidation = form.checkValidity();

    tempValidation = form.checkValidity();

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let updatedMutasiStok = await axios.post(
          `${tempUrl}/updateMutasiStokTotal/${mutasiStokId}`,
          {
            tglMutasiStok,
            // Total
            total,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        navigate(`/daftarMutasiStok`);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Mutasi Stok</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveMutasiStok}>
        <Card>
          <Card.Header>Data Mutasi Stok</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Bukti :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noBuktiMutasiStok} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal{" "}
                        {isMutasiStokSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglMutasiStok}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglMutasiStok(date);
                            getNextKodeMutasiStok(date);
                            if (kodeStok) getSaldoStokTanggal(kodeStok);
                          }}
                          disabled={isMutasiStokSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode COA{" "}
                        {isMutasiStokSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={coaOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeCOA.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeCOA(value.label);
                            } else {
                              setKodeCOA("");
                            }
                          }}
                          value={kodeCOA}
                          disabled={
                            isMutasiStokSaved ||
                            (tipeMutasiStokChild === "KREDIT" && true)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Catatan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={keterangan}
                          onChange={(e) => {
                            setKeterangan(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isMutasiStokSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            type="submit"
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={saveMutasiStokChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="5" style={textRight}>
                        Saldo Tanggal :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={saldoStokTanggal} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={tipeMutasiStokChild}
                          onChange={(e) => {
                            setTipeMutasiStokChild(e.target.value);
                          }}
                          disabled={isInputStok === true ? false : true}
                        >
                          {tipeMutasiStokChildOption.map(
                            (tipeMutasiStokChild) => (
                              <option value={tipeMutasiStokChild}>
                                {tipeMutasiStokChild}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            const tempValue = values.value;
                            setQuantity(tempValue);

                            let tempTotalMutasiStokChild =
                              parseFloat(tempValue) * parseFloat(hargaSatuan);
                            setTotalMutasiStokChild(tempTotalMutasiStokChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Satuan :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={hargaSatuan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalMutasiStokChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table aria-label="simple table">
            <TableHead className={classes.root}>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Kode
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Nama Stok
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Tipe
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Qty.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Sat.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Harga
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Total Rp.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Aksi
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mutasiStokChilds.map((user, index) => (
                <TableRow
                  key={user.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { bgcolor: Colors.grey300 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {user.stok.kodeStok}
                  </TableCell>
                  <TableCell>{user.stok.namaStok}</TableCell>
                  <TableCell>{user.tipeMutasiStokChild}</TableCell>
                  <TableCell align="right">
                    {user.quantity.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>{user.stok.satuanKecilStok}</TableCell>
                  <TableCell align="right">
                    {user.hargaSatuan.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.totalMutasiStokChild.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    <ButtonGroup variant="contained">
                      <Button
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          handleClickOpenUbah(e);
                          setIdMutasiStokChild(user.id);
                          setKodeStok(user.stok.kodeStok);
                          setNamaStok(user.stok.namaStok);
                          getSaldoStokTanggal(user.stok.kodeStok);
                          setTipeMutasiStokChild(user.tipeMutasiStokChild);
                          setQuantityLama(user.quantity);
                          setQuantity(user.quantity);
                          setHargaSatuan("0");
                          setTotalMutasiStokChild("0");
                          // setHargaSatuan(user.hargaSatuan);
                          // setTotalMutasiStokChild(user.totalMutasiStokChild);
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        color="error"
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          deleteMutasiStokChild(
                            e,
                            user.id,
                            user.quantity,
                            user.totalMutasiStokChild
                          );
                        }}
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Form noValidate validated={validated} onSubmit={saveMutasiStokTotal}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarMutasiStok")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={mutasiStokId === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}

      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        await getSaldoStokTanggal(stok.kodeStok);
                        setQuantityLama("0");
                        setQuantity("0");
                        // setHargaSatuan(stok.hargaJualStok);
                        setHargaSatuan("0");
                        setTotalMutasiStokChild("0");

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleCloseUbah}
        aria-labelledby="customized-dialog-title"
        open={openUbah}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Ubah Barang Mutasi Stok
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseUbah}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          dividers
          //  sx={{ height: "200px" }}
        >
          <div>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Kode / Barcode :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={pilihStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Nama Stok :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={namaStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="5" style={textRight}>
                        Saldo Tanggal :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={saldoStokTanggal} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Tipe <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Select
                      required
                      value={tipeMutasiStokChild}
                      onChange={(e) => {
                        setTipeMutasiStokChild(e.target.value);
                      }}
                    >
                      {tipeMutasiStokChildOption.map((tipeMutasiStokChild) => (
                        <option value={tipeMutasiStokChild}>
                          {tipeMutasiStokChild}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Quantity <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={quantity}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        const tempValue = values.value;
                        setQuantity(tempValue);

                        let tempTotalMutasiStokChild =
                          parseFloat(tempValue) * parseFloat(hargaSatuan);
                        setTotalMutasiStokChild(tempTotalMutasiStokChild);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Satuan :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      value={hargaSatuan}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={totalMutasiStokChild}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={updateMutasiStokChild}
          >
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahMutasiStok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
